import { toast } from "sonner";
import request from "../../helpers/request";
import { getUser } from "../../helpers/user";
import { Navigate } from "react-router-dom";

interface IRequestForgotPass {
  login: string;
  email: string;
  novaSenha?: string;
  confirmSenha?: string;
}

const acesso = async (params: IRequestForgotPass) => {
  try {
    const usuario = getUser();

    if (usuario === null) {
      const url = `${process.env.REACT_APP_API}/Usuario/ForgotPassword?login=${params.login}&email=${params.email}`;
      const result = await request({ url, noProtect: true });

      console.log("result", result);

      if (result.data) {
        toast.success("Email de recuperação enviado com sucesso!");
        Navigate({ to: "/Ativar-acesso" });
        return result.data;
      } else {
        throw new Error(result.data);
      }
    } else {
      const result = await request({
        url: `${process.env.REACT_APP_API}/Usuario/AlteracaoSenha`,
        method: "POST",
        data: {
          senha: params.novaSenha,
          id: usuario.usuario?.id,
        },
        headers: {
          Authorization: `Bearer ${usuario.token}`,
        },
        noProtect: true,
      });

      if (result.data) {
        toast.success("Senha alterada com sucesso!");
        return result.data;
      } else {
        throw new Error(result.data);
      }
    }
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }
  }
};

export default acesso;
